import { useEffect, useState } from "react";

export const usePushToDataLayer = (
  price,
  category,
  sanity_id,
  business_vertical
) => {
  const [hasPushed, setHasPushed] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && !hasPushed) {
      const timeout = setTimeout(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "view_item",
          value: { price },
          category,
          item: [
            {
              id: sanity_id,
              google_business_vertical: business_vertical,
            },
          ],
        });
        setHasPushed(true); 
      }, 1000);

      return () => clearTimeout(timeout);
    }
  }, [price, category, sanity_id, business_vertical, hasPushed]);
};